import { render, staticRenderFns } from "./NewsStatusCell.vue?vue&type=template&id=2cbc86b0&scoped=true&"
import script from "./NewsStatusCell.vue?vue&type=script&lang=js&"
export * from "./NewsStatusCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc86b0",
  null
  
)

export default component.exports